import { render, staticRenderFns } from "./a-loading.vue?vue&type=template&id=77ae5f6a&scoped=true"
import script from "./a-loading.vue?vue&type=script&lang=js"
export * from "./a-loading.vue?vue&type=script&lang=js"
import style0 from "./a-loading.vue?vue&type=style&index=0&id=77ae5f6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ae5f6a",
  null
  
)

export default component.exports